import { render, staticRenderFns } from "./bairshlaar.vue?vue&type=template&id=6cfeb570&scoped=true&"
import script from "./bairshlaar.vue?vue&type=script&lang=js&"
export * from "./bairshlaar.vue?vue&type=script&lang=js&"
import style0 from "./bairshlaar.vue?vue&type=style&index=0&id=6cfeb570&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfeb570",
  null
  
)

export default component.exports